import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('xeroReport', 'xeroReports');

const customActions = {
  async LOAD_xeroReports({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('xeroReports')
      .query({ $filter: 'IsDeleted eq false', $expand: 'Rows($expand=Cells)' });
    commit('SET_xeroReports', data);
  },
};

export default { ...actions, ...customActions };
